export default __webpack_public_path__ + "static/media/Shatush of Pandemonium.b5cf9de6.jpg";